var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteSendLine1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7382 7.26107L6.52284 12.7626L11.5918 15.6964L16.0614 11.2256C16.2882 10.999 16.5956 10.8718 16.9161 10.8719C17.2367 10.872 17.544 10.9995 17.7706 11.2262C17.9972 11.453 18.1244 11.7604 18.1243 12.0809C18.1242 12.4015 17.9967 12.7088 17.77 12.9354L13.2992 17.4062L16.2354 22.474L21.7382 7.26107ZM22.1285 4.54957C23.5724 4.02636 24.9717 5.42561 24.4485 6.86957L18.066 24.5173C17.5416 25.9649 15.5648 26.1413 14.7927 24.8085L10.9055 18.0926L4.18955 14.2054C2.85676 13.4332 3.03317 11.4564 4.48076 10.932L22.1285 4.54957Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteSendLine1);
export default __webpack_public_path__ + "static/media/mingcute_send-line1.02280614a75350b24bc842fd35b618ae.svg";
export { ForwardRef as ReactComponent };